import React from 'react';
import MotionComponent from './MotionComponent';
import { Link } from 'react-router-dom';

function Error() {
    return (
        <MotionComponent tag='section' className='notfound' content={
            <div>
                <h1 className="heading1">400 Error</h1>
                <p>An Error Occured</p>
                <button className="btn"><Link to="/" replace>Back to Home</Link></button>
            </div>
        } />
    );
}

export default Error;